'use strict'

import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL || 'https://chocomint.dulcetsehr.net',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/add',
      name: 'add',
      component: () => import('./views/Form.vue')
    },
    {
      path: '/details/:idx',
      name: 'detail',
      component: () => import('./views/Detail.vue')
    },
    {
      path: '/edit/:idx',
      name: 'edit',
      component: () => import('./views/Form.vue')
    },
    {
      path: '*',
      redirect: '/'
    },
  ]
})
